import React, { useEffect, useState } from "react";
import { Spin, Card, Row, Button } from "antd";

import { FONT, USER_STORAGE } from "constants/index";
import FormLoadUserComparation from "./load-control-drawer-comparation";
import { getById } from "services/user/user-service";
import { formNewUserControl } from "./load-control-drawer-new-control";
import DrawerApp from "components/drawer-app";
import {
  getControlByUser,
  getControlByUserBoot,
  saveControl,
} from "services/control/control-service";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { notificationErroInternal, notificationSucess } from "util/api-utils";

dayjs.extend(customParseFormat);
const dateFormat = "DD/MM/YYYY";
const dateFormatIso = "YYYY-MM-DD";

const LoadControlClientUser = () => {
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [isBoot, setIsBoot] = useState(null);
  const formRef = React.useRef(null);
  const [imgAvatar, setImgAvatar] = useState("");
  const [open, setOpen] = useState(false);
  const [userControl, setUserControl] = useState({});
  const [nowControl, setNowControl] = useState({});

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { id } = JSON.parse(localStorageItem);
      getById(id).then((res) => {
        setIsBoot(res.isBoot);
        setUserId(id);
        setLoading(false);
        setImgAvatar(res.img);
        getData(id, res.isBoot);
      });
    }
  }, [localStorage.getItem(USER_STORAGE)]);
  const onClose = () => {
    formRef.current?.resetFields();
    setOpen(false);
  };

  function getData(id, isBoot) {
    var funcGet = isBoot == true ? getControlByUserBoot : getControlByUser;
    funcGet(id)
      .then((res) => {
        const date = dayjs(new Date());
        const dateString = date.format(dateFormatIso);
        const nowControl = res?.controlActual?.controls?.find(
          (item) => item.date == dateString
        );
        setNowControl(nowControl);
        setUserControl(res);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err)
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde."
        );
      });
  }

  const handleNewControl = () => {
    setLoading(true);

    formRef?.current
      ?.validateFields()
      .then((values) => {
        values.userId = userId;
        values.reviewId = userControl.controlActual?.reviewId
        values.id = nowControl?.id;
        values.date = values.date.format(dateFormat);
        saveControl(values)
          .then(() => {
            setLoading(false);
            notificationSucess();
            onClose();
          })
          .catch((err) => {
            setLoading(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde."
            );
          });
      })
      .catch((errors) => {
        setLoading(false);
        console.log(errors);
      });
  };
  const showDrawer = () => {
    setOpen(true);

    setTimeout(() => {
      formRef.current?.setFieldsValue({
        name: userControl.name,
        date: dayjs(new Date()),
        cmjFirst: nowControl?.cmjFirst,
        cmjSecond: nowControl?.cmjSecond,
        fatigue: nowControl?.fatigue,
        humor: nowControl?.humor,
        pain: nowControl?.pain,
        sleep: nowControl?.sleep,
        stress: nowControl?.stress,
      });
    }, 300);
  };

  return (
    <div className="container-load-client">
      <Spin size="large" spinning={loading}>
        <Card style={{ backgroundColor: "#ffffff" }}>
          <Row style={{ margin: 5 }} justify="end">
            <Button
              style={{
                fontFamily: FONT,
                background: "#14B8A6",
                color: "#ffffff",
              }}
              onClick={() => showDrawer()}
            >
              Registrar Controle
            </Button>
          </Row>
          <FormLoadUserComparation userId={userId} isBoot={isBoot} />
        </Card>
      </Spin>

      <DrawerApp
        open={open}
        onClose={onClose}
        title={"Registrar Controle"}
        body={formNewUserControl(formRef, imgAvatar)}
        size={"large"}
        actionSave={handleNewControl}
        width={outerWidth < 501 ? "100%" : "60%"}
      />
    </div>
  );
};
export default LoadControlClientUser;
